// extracted by mini-css-extract-plugin
export var articleStructuredText = "pdf-module--articleStructuredText--d5063";
export var button = "pdf-module--button--13e70";
export var container = "pdf-module--container--c3e72";
export var downloadInput = "pdf-module--downloadInput--a880d";
export var title = "pdf-module--title--d92ad";